import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import reduce from 'lodash/reduce';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import RunStopsList from '../RunStopsList/RunStopsList';
import { getIsFetching, getRunById, loadRun } from '../../modules/runs/duck';
import { formatDateTime } from '../../shared/utils/date';
import { formatRun, formatStopLocation } from '../../shared/utils/run';

class RunStopsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stops: [],
            runId: '',
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.runId !== this.props.runId && this.props.runId) {
            this.props.loadRun(this.props.runId);
            this.setState({
                stops: [],
            });
        }
        if (this.props.run !== prevProps.run && this.props.run) {
            let stops = this.props.run.wayPoints
                ? reduce(this.props.run.wayPoints, (stops, wp) => stops.concat(wp.stops), [])
                : null;
            this.setState({
                stops: stops,
            });
        }
    }

    goToRunDetails = () => {
        this.props.router.push(`/runs/${this.props.runId}`);
    };

    renderLoadInfo = runInfo => {
        if (runInfo.loadTime) {
            return (
                'Manifest(s) loading on ' +
                formatDateTime(runInfo.loadTime) +
                ' at ' +
                formatStopLocation(runInfo.loadStop)
            );
        }
        return 'Manifest(s) loading at ' + formatStopLocation(runInfo.loadStop);
    };

    renderUnloadInfo = runInfo => {
        if (runInfo.unloadTime) {
            return (
                'Manifest(s) unloading on ' +
                formatDateTime(runInfo.unloadTime) +
                ' at ' +
                formatStopLocation(runInfo.unloadStop)
            );
        }
        return 'Manifest(s) unloading at ' + formatStopLocation(runInfo.unloadStop);
    };

    renderLoadUnloadInfo = () => {
        const info = this.props.runInfo;

        if (!info) {
            return null;
        }

        return (
            <Row>
                <Col sm={12}>
                    <p>{this.renderLoadInfo(info)}</p>
                    <p>{this.renderUnloadInfo(info)}</p>
                </Col>
            </Row>
        );
    };

    render() {
        const { stops } = this.state;
        return (
            <Modal show={this.props.showModal} bsSize="large">
                <Modal.Header>
                    <Modal.Title>{`Run ${
                        this.props.run ? formatRun(this.props.run) : 'Run'
                    }`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 style={{ marginTop: 0 }}>Manifest(s)</h4>
                    {this.renderLoadUnloadInfo()}
                    <h4>Stops</h4>
                    <RunStopsList stops={stops} />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="warning"
                        onClick={this.goToRunDetails}
                    >
                        Go to Run Details
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={this.props.onClose}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

RunStopsModal = connect(
    (state, ownProps) => ({
        isFetching: getIsFetching(state),
        run: getRunById(state, ownProps.runId),
    }),
    {
        loadRun,
    }
)(RunStopsModal);

export default withRouter(RunStopsModal);
